import React, { useCallback } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// MUI
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// MUI Icons
import HelpIcon from '@mui/icons-material/Help';

// Styles
import styles from './style.module.scss';

const FileTypeTooltip: React.FC = () => {
  const { t } = useTranslation();

  const renderText = useCallback(() => {
    return (
      <div className={styles.text_container}>
        <Typography variant='body2'>
          {t('attachMaterials.file_types.part1')}
        </Typography>

        <Typography variant='body2'>
          - {t('attachMaterials.file_types.pdf')}
        </Typography>

        <Typography variant='body2'>
          - {t('attachMaterials.file_types.images')}
        </Typography>

        <Typography variant='body2'>
          - {t('attachMaterials.file_types.word_documents')}
        </Typography>

        <Typography variant='body2'>
          - {t('attachMaterials.file_types.text_files')}
        </Typography>

        <Typography variant='body2'>
          - {t('attachMaterials.file_types.audio_files')}
        </Typography>

        <Typography variant='body2'>
          - {t('attachMaterials.file_types.video_files')}
        </Typography>
      </div>
    )
  }, [t])
  return (
    <Tooltip
      title={renderText()}
      classes={{ tooltip: styles.tooltip }}
      disableTouchListener={false}
      enterTouchDelay={0}
    >
      <HelpIcon className={styles.icon} />
    </Tooltip>
  )
}

export default FileTypeTooltip;
